export default "__VITE_ASSET__CJ8FLcc3__"